import { useNavigate } from "react-router-dom";

export default function Success() {
  const navigate = useNavigate();

  const handleReturn = () => {
    navigate("/dashboard", { replace: true });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-md space-y-8 rounded-xl bg-white p-10 shadow-lg">
        <div className="text-center">
          <h1 className="mb-2 text-4xl font-bold text-gray-900">Success! 🎉</h1>
          <p className="mb-8 text-lg text-gray-600">
            Your payment has been processed successfully.
          </p>
          <button
            onClick={handleReturn}
            className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-3 text-sm font-medium text-white shadow-sm transition-colors hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Return Back
          </button>
        </div>
      </div>
    </div>
  );
}

// ?customer_session_token=polar_cst_t33RWpZJ1CzVSJkq7eJ5bDuG36OJRX11HpCD93zVZ5n
